import React, { useMemo } from "react";
import { Box, Typography, Button } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";
import { useNavigate, useLocation, matchPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import themeObject from "../../styles/theme/theme";

const muiTheme = createTheme(themeObject);

const KycBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, user } = useSelector((state) => state.auth);

  const isVisible = useMemo(() => {
    // const isKycVerified =
    //   user?.kyc_verified === 1 ||
    //   user?.kyc_verified === "1" ||
    //   user?.kyc_verified === true;
    const isEmailVerified =
      user?.email_verified_at !== null && user?.email_verified_at !== undefined;
    const isPhoneVerified =
      user?.phone_verified_at !== null && user?.phone_verified_at !== undefined;
    const isContactVerified = isEmailVerified && isPhoneVerified;
    if (!token || user?.role !== "buyer"|| isContactVerified) return false;
    //  || isKycVerified 
    // console.log(
    //   "KYC Banner: User is unverified buyer, checking path for banner display...",
    //   isKycVerified,
    //   location.pathname,
    // );
    console.log("KYC Banner: User is unverified buyer, checking path for banner display...", isContactVerified, location.pathname);
    const bannerPaths = [
      "/buy",
      "/sell",
      "/market",
      "/new-market",
      "/profile",
      "/dashboard",
    ];
    return bannerPaths.some((pattern) => {
      const isParameterized = pattern.includes(":");
      return matchPath(
        { path: pattern, end: !isParameterized },
        location.pathname,
      );
    });
  }, [token, user, location.pathname]);

  if (!isVisible) return null;

  return (
    <ThemeProvider theme={muiTheme}>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1280px", // Match standard large containers
          mx: "auto",
          mt: { xs: 2, sm: 4 }, // Reduced top margin for page-level integration
          mb: { xs: 2, sm: 4 },
          px: { xs: 2, sm: 4 }, // Add some side margin for the card look
        }}
      >
        <Box
          sx={{
            background: "rgba(243, 216, 129, 0.89)", // Pale gold background
            borderRadius: "20px",
            py: { xs: 3, sm: 4 },
            px: { xs: 3, sm: 6 },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 3, sm: 4 },
            boxShadow: "0 12px 30px rgba(180, 83, 9, 0.12)",
            border: "1px solid rgba(255, 255, 255, 0.4)",
            position: "relative",
            backdropFilter: "blur(10px)", // Glass effect
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 3, sm: 4 },
            }}
          >
            <Box
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.4)",
                p: 1.5,
                borderRadius: "14px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
              }}
            >
              <InfoIcon sx={{ color: "#2d3748", fontSize: "32px" }} />
            </Box>
            <Box>
              <Typography
                variant="h5"
                sx={{
                  color: "#2d3748",
                  fontWeight: 900,
                  fontSize: { xs: "1.2rem", sm: "1.5rem" },
                  mb: 0.5,
                  letterSpacing: "-0.02em",
                }}
              >
                Verify Your Profile
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "rgba(45, 55, 72, 0.9)",
                  fontWeight: 500,
                  fontSize: { xs: "0.9rem", sm: "1.05rem" },
                  lineHeight: 1.4,
                  maxWidth: "650px",
                }}
              >
                You're one step away! Verify your profile to start bidding on
                trades and buying products instantly.
              </Typography>
            </Box>
          </Box>

          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/kyc-verification")}
            sx={{
              backgroundColor: "#2d3748",
              color: "#FFFFFF",
              fontWeight: 900,
              textTransform: "none",
              px: 5,
              py: 1.8,
              borderRadius: "14px",
              fontSize: "1.05rem",
              whiteSpace: "nowrap",
              boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
              "&:hover": {
                backgroundColor: "#1a202c",
                transform: "translateY(-3px)",
                boxShadow: "0 15px 30px rgba(0,0,0,0.18)",
              },
              transition: "all 0.3s cubic-bezier(0.2, 0, 0, 1)",
              minWidth: "180px",
              mt: { xs: 1, md: 0 },
            }}
          >
            Verify Now
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default KycBanner;
